import React from 'react';
import {
  Box,
  Button,
  Grid,
  TextField,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { fetchFilteredPublishers, setFilter, resetFilters } from 'features/publishers/slices/publishersSlice';


const PublisherFilters: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { filters } = useSelector((state: RootState) => state.publishers);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    dispatch(setFilter({ key: 'searchTerm', value }));
  };

  const handleApplyFilters = () => {
    dispatch(fetchFilteredPublishers(filters));
  };

  const handleResetFilters = () => {
    dispatch(resetFilters());
    dispatch(fetchFilteredPublishers({}));
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleApplyFilters();
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} sm={6} md={8}>
          <TextField
            fullWidth
            label="Search Publishers"
            variant="outlined"
            value={filters.searchTerm || ''}
            onChange={handleSearchChange}
            onKeyDown={handleKeyDown}
            placeholder="Search by name, tagline, location..."
          />
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleApplyFilters}
            >
              Apply Filters
            </Button>
            <Button
              variant="outlined"
              onClick={handleResetFilters}
            >
              Reset
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PublisherFilters;